export default __webpack_public_path__ + "static/media/35.d9c3ca8a.jpg";